import { ExerciseCategoryDto } from '../../../../shared/dtos/exerciseCategory.dto';
import { FC, ReactElement, ReactNode } from 'react';
import i18next from 'i18next';
import DataTable, { DataTableColumn } from '../data-table/DataTable';
import StatusBadge from '../data-table/StatusBadge';

type ExerciseCategoriesTableProps = {
  categories: ExerciseCategoryDto[];
  isLoading: boolean;
  toolbar?: ReactNode;
  onClick?: (category: ExerciseCategoryDto) => void;
}

const ExerciseCategoriesTable: FC<ExerciseCategoriesTableProps> = ({
  categories,
  isLoading,
  toolbar,
  onClick,
}: ExerciseCategoriesTableProps): ReactElement => {
  const columns: DataTableColumn<ExerciseCategoryDto>[] = [
    {
      key: 'germanTitle',
      header: i18next.t('exerciseCategory.germanTitle'),
      cell: (category: ExerciseCategoryDto) => <span className="fw-semibold">{category.de}</span>,
    },
    {
      key: 'englishTitle',
      header: i18next.t('exerciseCategory.englishTitle'),
      cell: (category: ExerciseCategoryDto) => <span className="text-muted">{category.en}</span>,
    },
    {
      key: 'isActive',
      header: i18next.t('exerciseCategory.isActive'),
      cell: (category: ExerciseCategoryDto) => (
        <StatusBadge
          isActive={category.isActive}
          label={i18next.t(category.isActive ? 'exerciseCategory.active' : 'exerciseCategory.notActive')}
        />
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={categories}
      rowKey={(category: ExerciseCategoryDto) => category.id}
      onRowClick={onClick}
      isLoading={isLoading}
      toolbar={toolbar}
    />
  );
};

export default ExerciseCategoriesTable;
